export default __webpack_public_path__ + "static/media/130.d1b2039f.jpg";